import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import BetslipView from './betslip-view/index.js';
import { isEqual, isEmpty } from 'mojito/utils';
import { connect } from 'react-redux';

const AnalyticsContextExtender = MojitoCore.Presentation.AnalyticsContext.ContextExtender;
const AnalyticsContextBuilder = MojitoCore.Presentation.AnalyticsContext.ContextBuilder;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const EventDataDescriptors = MojitoServices.SportsContent.Events.descriptors;
const { selectCurrency } = MojitoServices.UserInfo.selectors;
const { selectors: userBonusesSelectors } = MojitoServices.UserBonuses;
const {
    utils: BetslipUtils,
    selectors: betslipSelectors,
    actions: betslipActions,
} = MojitoServices.Betslip;
const { selectActiveFreeBets } = userBonusesSelectors;
const {
    selectBetslip,
    selectActiveStakeGroup,
    selectIsStakeGroupActivationPending,
    selectReceipt,
    selectIsBetPlacementAllowed,
    selectIsBonusValidationPending,
    selectHasSuspendedBet,
    selectHasExpiredBet,
    selectHasHcapChangeBet,
    selectHasBoostedHcapChangeBet,
    selectHasOddsChangeBet,
    selectHasPendingBankerBet,
    selectBetslipStatus,
    selectValidationErrors,
    selectOverask,
    selectBankersActivated,
    selectCommitBetslipMode,
} = betslipSelectors;

class BetslipControllerView extends UIViewImplementation {
    constructor(props) {
        super(props);

        this.populateData(BetslipUtils.getParts(this.props.betslip));

        this.analyticsContext = new AnalyticsContextBuilder().withAnalyticsPath('Betslip').build();
        this.onAcceptBetslipTechnicalError = this.onAcceptBetslipTechnicalError.bind(this);
    }

    componentDidUpdate(prevProps) {
        const previousBetslipParts = BetslipUtils.getParts(prevProps.betslip);
        const currentBetslipParts = BetslipUtils.getParts(this.props.betslip);
        if (!isEqual(previousBetslipParts, currentBetslipParts)) {
            this.populateData(currentBetslipParts);
        }
    }

    populateData(betslipParts) {
        const partInfos = betslipParts.map(part => part.partInfo);
        const eventIds = partInfos.map(partInfo => partInfo.eventId);
        this.controllerHelper().requestData(EventDataDescriptors.createEventsDescriptor(eventIds));
        partInfos.forEach(partInfo => {
            const { marketId } = partInfo;
            this.controllerHelper().requestData(
                EventDataDescriptors.createEventMarketDescriptor(marketId)
            );
        });
    }

    onAcceptBetslipTechnicalError() {
        const { dispatch } = this.props;
        dispatch(betslipActions.initBetslip());
    }

    render() {
        return (
            <AnalyticsContextExtender value={this.analyticsContext}>
                <BetslipView
                    config={this.config.view}
                    betslip={this.props.betslip}
                    currencyCode={this.props.currencyCode}
                    freeBets={this.props.freeBets}
                    hasPendingBonus={this.props.hasPendingBonus}
                    betPlacementButtonDisabled={this.props.betPlacementButtonDisabled}
                    hasOddsChangeBet={this.props.hasOddsChangeBet}
                    hasHcapChangeBet={this.props.hasHcapChangeBet}
                    hasBoostedHcapChange={this.props.hasBoostedHcapChange}
                    stakeGroup={this.props.stakeGroup}
                    isStakeGroupPending={this.props.isStakeGroupPending}
                    hasPendingBankerBet={this.props.hasPendingBankerBet}
                    showReceipt={!!this.props.receipt}
                    isSuspended={this.props.isSuspended}
                    isExpired={this.props.isExpired}
                    betslipStatus={this.props.betslipStatus}
                    validationErrors={this.props.validationErrors}
                    onClearReceipt={this.props.onClearReceipt}
                    showOverask={this.props.showOverask}
                    bankersActivated={this.props.bankersActivated}
                    commitBetslipMode={this.props.commitBetslipMode}
                    onAcceptTechnicalError={this.onAcceptBetslipTechnicalError}
                />
            </AnalyticsContextExtender>
        );
    }
}

const mapStateToProps = state => ({
    betslip: selectBetslip(state),
    stakeGroup: selectActiveStakeGroup(state),
    isStakeGroupPending: selectIsStakeGroupActivationPending(state),
    hasPendingBankerBet: selectHasPendingBankerBet(state),
    receipt: selectReceipt(state),
    betPlacementButtonDisabled: !selectIsBetPlacementAllowed(state),
    hasPendingBonus: selectIsBonusValidationPending(state),
    isSuspended: selectHasSuspendedBet(state),
    isExpired: selectHasExpiredBet(state),
    betslipStatus: selectBetslipStatus(state),
    hasHcapChangeBet: selectHasHcapChangeBet(state),
    hasBoostedHcapChange: selectHasBoostedHcapChangeBet(state),
    hasOddsChangeBet: BetslipUtils.isTeaser(selectActiveStakeGroup(state))
        ? false
        : selectHasOddsChangeBet(state),
    validationErrors: selectValidationErrors(state),
    showOverask:
        BetslipUtils.isOverask(selectBetslipStatus(state)) || !isEmpty(selectOverask(state)),
    bankersActivated: selectBankersActivated(state),
    currencyCode: selectCurrency(state),
    freeBets: selectActiveFreeBets(state),
    commitBetslipMode: selectCommitBetslipMode(state),
});

export default connect(mapStateToProps)(BetslipControllerView);
